import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../baseQuery';
import { TransactionHistoryResponse, TransactionHistoryRequest } from 'types/interfaces/transaction';

export const transactionApi = createApi({
  reducerPath: 'transactionApi',
  baseQuery: baseQuery,
  tagTypes: ['Transactions'],
  endpoints: (builder) => ({
    getTransactionHistory: builder.query<TransactionHistoryResponse, TransactionHistoryRequest>({
      query: ({ page = 1, pageSize = 50 }) => ({
        url: `/transactions/me?page=${page}&pageSize=${pageSize}`,
        method: 'GET',
        requiresAuth: true,
      }),
      providesTags: ['Transactions'],
    }),
  }),
});

export const { useGetTransactionHistoryQuery } = transactionApi;
